import { rest } from 'msw'
import { LedgerWalletsResponse } from 'types/ledger/ledgerWalletTransactions'
import mockRewardsWallets from '../../../__mocks__/Wallets/rewardsWallets.json'

const API_URL = process.env.API_URL

export const getRewardsWallets = rest.get<LedgerWalletsResponse>(
  `${API_URL}/ledger/v1/wallets`,
  async (req, res, ctx) => {
    const currencyCode = req.url.searchParams.get('currencyCode')

    // If no currency filter, return all wallets
    if (!currencyCode) {
      return res(ctx.json(mockRewardsWallets))
    }

    // Filter wallets by single currency
    const filteredContent = mockRewardsWallets.content.filter(
      wallet => wallet.balance.currencyCode === currencyCode.toUpperCase()
    )

    // Return filtered response with updated metadata
    return res(
      ctx.json({
        ...mockRewardsWallets,
        content: filteredContent,
        totalElements: filteredContent.length,
        numberOfElements: filteredContent.length,
        empty: filteredContent.length === 0,
        totalPages: Math.ceil(filteredContent.length / mockRewardsWallets.size) || 1,
        last: filteredContent.length <= mockRewardsWallets.size,
      })
    )
  }
)
